import { handleServiceError } from '../helpers/app';
import { ResponseObject } from '../interfaces/App';
import apiRequest from './apiService';

/** Metadata for a company Zapier Platform API key (secret never returned after create). */
export interface ZapierApiKeyMeta {
  id: string;
  prefix: string;
  created_at: string;
  created_by?: string | null;
}

export interface ZapierApiKeyCreated extends ZapierApiKeyMeta {
  /** Plaintext secret — shown once on create only. */
  api_key: string;
}

export interface ZapierApiKeysListResponse {
  keys: ZapierApiKeyMeta[];
}

/**
 * List Zapier Platform API keys for the caller's company (metadata only).
 */
export const listZapierApiKeys = async (): Promise<ResponseObject> => {
  try {
    return await apiRequest('agent', 'GET', '/integrations/zapier/api-keys');
  } catch (err: unknown) {
    return handleServiceError(err, 'agent');
  }
};

/**
 * Create a new Zapier Platform API key. Response includes plaintext once.
 */
export const createZapierApiKey = async (): Promise<ResponseObject> => {
  try {
    return await apiRequest('agent', 'POST', '/integrations/zapier/api-keys');
  } catch (err: unknown) {
    return handleServiceError(err, 'agent');
  }
};

/**
 * Revoke a Zapier Platform API key by id.
 */
export const revokeZapierApiKey = async (
  keyId: string
): Promise<ResponseObject> => {
  try {
    return await apiRequest(
      'agent',
      'DELETE',
      `/integrations/zapier/api-keys/${keyId}`
    );
  } catch (err: unknown) {
    return handleServiceError(err, 'agent');
  }
};
